import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import PagePanel from "app/components/PagePanel";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import PostingForm from "app/components/PostingForm";
import { shallowEqual, useSelector } from "react-redux";
import { fetchMediaById } from "app/actions/media-library-data";
import { RootState } from "typedefs";
import { useActions } from "app/utils/hooks";
import { createPost } from "../../../actions/postingForm";
import { PostingModel } from "app/models/PostModel";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import usePlanFeature from "app/utils/services/plan_feature/user";
import { MediaModel } from "app/models";

const CreatePostWithMedia = () => {
  const { t } = useTranslation();
  const params = useParams<{ id: string }>();
  const [mediaData, setMediaData] = useState<MediaModel[]>();

  const resourceActions = useActions({
    fetchMediaById,
    createPost,
  });
  const user = useSelector((state: RootState) => state.user.self, shallowEqual);
  const history = useHistory();
  const { canSchedulePosts, canAddMedia, canPostMedia } = usePlanFeature(user);

  const route = (path: string) => {
    history.push(path);
  };

  const { selectedDestinations } = useSelector(
    (state: RootState) => state.destinations,
    shallowEqual,
  );

  useEffect(() => {
    if (params?.id) {
      resourceActions.fetchMediaById(params?.id).then((res) => {
        setMediaData([res]);
      });
    }
  }, [params?.id]);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const canUploadMedia = () => {
    if (!user) {
      return null;
    }
    return canAddMedia && canPostMedia;
  };

  const onPostHandler = (data: PostingModel) => {
    if (selectedDestinations.length === 0) {
      setErrorMessage(t("Please select location"));
      return;
    }

    setErrorMessage(null);
    if (!errorMessage || canUploadMedia) {
      resourceActions
        .createPost({ ...data })
        .finally(() => route("/resources"));
    }
  };

  const onCancel = () => history.goBack();

  return (
    <>
      <GettingStartedProgress />
      <div className={styles.container}>
        <PagePanel title={t("Create post with media")} />
        {mediaData && (
          <PostingForm
            attachmentProps={mediaData}
            postTextIsRequired
            locationsIsRequired
            canUploadMedia={canUploadMedia()}
            canSchedule={canSchedulePosts}
            expanded
            onPost={onPostHandler}
            disablePostButton={
              !canUploadMedia() ||
              (errorMessage && errorMessage.length > 0) ||
              !mediaData
            }
            hasSchedule={false}
            canSelectMedia={false}
            onCancel={onCancel}
          />
        )}
      </div>
    </>
  );
};

export default CreatePostWithMedia;
